import { faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons/faArrowCircleLeft";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const estilosBarraPesquisa = require("./barraPesquisa.module.scss").default;

export type BarraPesquisaProps = {
  onPesquisaPreVenda: () => void;
  onPesquisasAnteriores: () => void;
  onPesquisarCores?: () => void;
  pesquisandoNoOrcamentoVenda: boolean;
  desabilitarPesquisarHistorico: boolean
};

export const BarraPesquisa = (props: BarraPesquisaProps) => {
    {/* atenção 
         
          a pesquisa de produtos é usado em varios locais no sistema
          incluise em filtros para selecao multipla de produtos
         
         */}
  return (
    <div className={estilosBarraPesquisa.barraPesquisaContainer}>
      <div>
        {props.pesquisandoNoOrcamentoVenda &&
          <button id="BarraPesquisa_BotaoPesquisarPreVendas" className={estilosBarraPesquisa.buttonBarraPesquisa} onClick={() => props.onPesquisaPreVenda()}>
            <FontAwesomeIcon
              className={"material-icons"}
              color="#3c8ac9"
              icon={faSearch}
            />{" "}
            Pesquisar Pré-Vendas
          </button>
        }
        {props.desabilitarPesquisarHistorico &&
          <button id="BarraPesquisa_BotaoPesquisasAnteriores" className={estilosBarraPesquisa.buttonBarraPesquisa} onClick={() => props.onPesquisasAnteriores()}>
            <FontAwesomeIcon
              className={"material-icons"}
              color="#3c8ac9"
              icon={faSearch}
            />{" "}
            Pesquisas anteriores
          </button>
        }
         {props.pesquisandoNoOrcamentoVenda &&
        <button id="BarraPesquisa_BotaoPesquisarCores" className={estilosBarraPesquisa.buttonBarraPesquisa} onClick={() => props.onPesquisarCores()}>
          <FontAwesomeIcon
            className={"material-icons"}
            color="#3c8ac9"
            icon={faSearch}
          />{" "}
          Pesquisar Cores
        </button>
        }

         {/* atenção 
         
          a pesquisa de produtos é usado em varios locais no sistema
          incluise em filtros para selecao multipla de produtos
         
         */}
      </div>
    </div>
  );
};
 